import { render } from "./OrderImportModal.vue?vue&type=template&id=421d1e4c"
import script from "./OrderImportModal.vue?vue&type=script&lang=js"
export * from "./OrderImportModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__